<template>
    <div class="tools--employee">

        <!-- <action icon="add" color="green">{{ $t('page.roster.tools.apply') }}</action> -->

        <!-- <action icon="cancel" color="orange">{{ $t('page.roster.tools.cancel') }}</action> -->

        <action @click.native="signin" icon="add" color="green" v-if=" ! item.assigned">{{ $t('page.roster.tools.signin') }}</action>

        <action @click.native="cancelSignout" icon="check" color="green" v-if="signedOut">{{ $t('page.roster.tools.work') }}</action>

        <action @click.native="signout" icon="cancel" color="red" v-if="item.assigned && ! signedOut">{{ $t('page.roster.tools.signout') }}</action>
    </div>
</template>

<script>
import { mapState } from 'vuex';
// import events from '../../../events/events';
import shared from '../../../pages/planning/shared';

export default
{
    name: 'Employee',

    props: ['item'],

    data() {
        return {
            shared: shared.state,
        }
    },

    computed:
    {
        myPlaceholder()
        {
            return ! this.item.assigned && this.current.membership.duties.indexOf(this.item.duty) != -1;
        },

        signedOut()
        {
            return this.item.assigned && this.item.flag == 'signout';
        },

        ...mapState({
            current: ({ current }) => current,
        }),
    },

    methods:
    {
        signin()
        {
            this.$http.put('/api/items/' + this.item.id + '/sign-in')
            .then(response =>
            {
                let key = _.findIndex(this.shared.items, {id: this.item.id});

                // response contains item, we need to replace the whole item
                this.$set(this.shared.items, key, response.data);

                this.$tools.close();
            })
            .catch(error =>
            {
                // show general error "you already work that day"
                this.$modal.show(this.$t('page.roster.signin.error.headline'), this.$t('page.roster.signin.error.text'));
            });
        },

        signout()
        {
            this.$http.put('/api/items/' + this.item.id + '/sign-out')
            .then(response =>
            {
                this.$modal.show(this.$t('page.roster.signout.headline'), this.$t('page.roster.signout.text'), () =>
                {
                    this.item.flag = 'signout';
                    this.$tools.close();
                });
            });
        },

        cancelSignout()
        {
            this.$http.delete('/api/items/' + this.item.id + '/sign-out')
            .then(response =>
            {
                this.item.flag = null;
                this.$tools.close();
            });
        },
    },
}
</script>



// WEBPACK FOOTER //
// Employee.vue?52503456